import React from 'react';
import { Reveal } from './Reveal';
const steps = [{
  number: '01',
  title: 'Aprende',
  text: 'Conoce la industria y desarrolla nuevas habilidades.'
}, {
  number: '02',
  title: 'Desarróllate',
  text: 'Recibe capacitación y acompañamiento durante el proceso.'
}, {
  number: '03',
  title: 'Crece',
  text: 'Avanza de acuerdo con tu compromiso y resultados.'
}];
export function Opportunity() {
  return <section id="oportunidad" className="w-full scroll-mt-16 bg-ink py-24 sm:py-32 lg:py-44" aria-labelledby="opportunity-title" data-id="element-142" data-mp="2h1ieiuh9hoet">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-143" data-mp="2qrbmzmm3xneu">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1fr] lg:items-end lg:gap-24" data-id="element-144" data-mp="2qtxwvswh0f08">
          <Reveal data-id="element-145" data-mp="2vshh9ovf1iqh">
            <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-146" data-mp="2zsji5vtbu84p">
              La oportunidad
            </p>
            <h2 id="opportunity-title" className="mt-8 font-sans text-[2rem] font-light uppercase leading-[1.06] text-ivory sm:text-5xl xl:text-[3.6rem]" data-id="element-147" data-mp="34pa0kpsltfta">
              Aprende.
              <br data-id="element-148" data-mp="pcslz6a784lz" />
              Desarróllate.
              <br data-id="element-149" data-mp="pdli7dbj7bpv" />
              <span className="text-champagne" data-id="element-150" data-mp="pd2aepfli3pk">Crece.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.08} data-id="element-151" data-mp="kfk0avpudifz">
            <p className="max-w-xl font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-152" data-mp="1i1hnh6f62by9">
              Conoce una oportunidad independiente dentro de la industria de
              servicios financieros, con capacitación y acompañamiento durante
              tu proceso.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 border-t border-champagne/25 sm:mt-24 md:grid-cols-3" data-id="element-153" data-mp="13bjy4n5i3g7h">
          {steps.map((step, i) => <Reveal key={step.number} delay={i * 0.08} className={`border-b border-ivory/12 md:border-b-0 md:border-r md:last:border-r-0 ${i > 0 ? 'md:pl-10' : ''} ${i < steps.length - 1 ? 'md:pr-10' : ''}`} data-id="element-154" data-mp="20u1z7b2qi0eu" data-mpi={i}>
              <div className="py-9 md:py-12" data-id="element-155" data-mp="3ucsji6hi2li8">
                <span className="block font-serif text-4xl text-champagne sm:text-5xl" data-id="element-156" data-mp="3gk2xi21z1gl4">
                  {step.number}
                </span>
                <h3 className="mt-6 font-sans text-sm font-medium uppercase tracking-[0.2em] text-ivory" data-id="element-157" data-mp="3lgjk2rtivmw3">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-xs font-sans text-base font-light leading-relaxed text-steel-200" data-id="element-158" data-mp="3bkgj3paepuaq">
                  {step.text}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.12} data-id="element-159" data-mp="32k1y6r1cuh7r">
          <p className="mt-14 max-w-xl font-sans text-sm font-light leading-relaxed text-steel-400" data-id="element-160" data-mp="32ld0snj2dixa">
            Algunas actividades dentro de la industria requieren capacitación y
            las licencias correspondientes.
          </p>
        </Reveal>
      </div>
    </section>;
}